import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./HeroSlide.css";

export default function HeroSlide({ slide }) {
  const posX = slide.position?.x || "left";

  // Flexbox alignment maps
  const justifyMap = { left: "flex-start", center: "center", right: "flex-end" };
  const alignMap = { left: "flex-start", center: "center", right: "flex-end" };

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: posX === "right" ? 50 : -50 }, // Slide from the side
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <div className="hero-container">
      {/* Background Image Animation */}
      <motion.img
        initial={{ scale: 1.1, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5 }}
        src={slide.image}
        alt={slide.name}
        className="hero-bg-image"
      />

      {/* Centered Content Layer */}
      <div
        className="hero-content-viewport"
        style={{
          display: "flex",
          alignItems: "center", // Vertical Center
          justifyContent: justifyMap[posX],
          padding: "0 5%",
        }}
      >
        <motion.div
          className="hero-text-bundle"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          key={slide.id} // Forces re-animation on slide change
          style={{
            textAlign: posX,
            alignItems: alignMap[posX],
          }}
        >
          {slide.name && (
            <motion.h1 variants={itemVariants} className="hero-title">
              {slide.name}
            </motion.h1>
          )}

          {slide.subtitle && (
            <motion.h2 variants={itemVariants} className="hero-subtitle">
              {slide.subtitle}
            </motion.h2>
          )}

          {slide.description && (
            <motion.p variants={itemVariants} className="hero-description">
              {slide.description}
            </motion.p>
          )}

          {slide.cta && (
            <Link to={slide.link || "/"} className="hero-link-wrapper">
              <motion.button
                variants={itemVariants}
                whileHover={{ scale: 1.05, backgroundColor: "#f39c12", color: "#fff" }}
                whileTap={{ scale: 0.95 }}
                className="hero-button"
              >
                {slide.cta}
              </motion.button>
            </Link>
          )}
        </motion.div>
      </div>
    </div>
  );
}